module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"book:title-objects":"объектов","tools:add-new":"Добавить объект"},"en":{"book:title-objects":"objects","tools:add-new":"Add new object"}}')
  delete Component.options._Ctor
}
